import { useQuery, UseQueryResult } from '@tanstack/react-query';
import siteBatchService from '../services/SiteBatchService';
import { RunningSite } from '../models/SiteBatch';

const POLLING_INTERVAL_MS = 10_000;

export const runningSitesQueryKey = (projectId: string | null) =>
  ['site-batch', 'running-sites', projectId] as const;

interface UseRunningSitesOptions {
  enabled: boolean;
}

/**
 * Poll the list of "구동 중" sites (latest completed batch had router
 * success). Feeds the "현재 구동 중" banner and the 구동 상태 column in
 * the site list. Longer interval than activeBatches (10s vs 5s) because
 * this state changes only on batch completion, not on every step.
 */
export function useRunningSites(
  projectId: string | null,
  options: UseRunningSitesOptions,
): UseQueryResult<RunningSite[], Error> {
  const { enabled } = options;

  return useQuery<RunningSite[], Error>({
    queryKey: runningSitesQueryKey(projectId),
    queryFn: () => siteBatchService.listRunningSites(projectId as string),
    enabled: enabled && !!projectId,
    refetchInterval: () => {
      if (typeof document !== 'undefined' && document.hidden) return false;
      return POLLING_INTERVAL_MS;
    },
    refetchIntervalInBackground: false,
    retry: 2,
    staleTime: 2_000,
  });
}
